import COLORS from '../colors'

const NUMBER_INPUT_STYLES = {
  // helperText
  helperTextRoot: {
    display: 'none',
  },

  // InputLabelProps
  error: {
    '&&&': {
      color: COLORS.red,
    },
  },
  formControl: {
    '&&': {
      transform: 'translate(12px, 14px)',
      fontSize: '0.9rem',
      color: 'rgba(0, 0, 0, 0.40)',
    },
  },
  shrink: {
    '&&&': {
      transform: 'translate(12px, -6px)',
      fontSize: '12px',
      color: COLORS.black,
    },
  },

  // InputProps
  root: {
    borderRadius: '6px',
  },
  input: {
    height: '0.7rem',
    minHeight: '0.7rem',
    fontSize: '0.95rem',
    padding: '17px 12px 14px',
  },
  inputMultiline: {
    fontSize: '0.95rem!important',
  },
}

export default NUMBER_INPUT_STYLES
